import store from '../..';

export function setFilterOptions() {
  const allGroups = store.getters['account/getCurrentClient'].groups;
  const cities = [];
  for (let i = 0; i < allGroups.length; i++) {
    if (allGroups[i].address) {
      cities.push({
        text: allGroups[i].address.city,
        value: allGroups[i].uuid,
      });
    }
  }
  store.commit('filters/setKeyFilterOptions', {
    cities,
    used: [
      {
        text: 'Yes',
        value: true,
      },
      {
        text: 'No',
        value: false,
      },
    ],
  });
}
